"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/ethereum-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 6.11.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.V1Api = exports.V1ApiFactory = exports.V1ApiFp = exports.V1ApiAxiosParamCreator = exports.ValidationErrorMessageEnum = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
exports.ValidationErrorMessageEnum = {
    ValidationFailed: 'Validation failed'
};
/**
 * V1Api - axios parameter creator
 * @export
 */
const V1ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get the estimated gas cost of a transaction
         * @param {string} data input data
         * @param {string} from from address
         * @param {string} to to address
         * @param {string} value transaction value in wei
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        estimateGas: async (data, from, to, value, options = {}) => {
            // verify required parameter 'data' is not null or undefined
            (0, common_1.assertParamExists)('estimateGas', 'data', data);
            // verify required parameter 'from' is not null or undefined
            (0, common_1.assertParamExists)('estimateGas', 'from', from);
            // verify required parameter 'to' is not null or undefined
            (0, common_1.assertParamExists)('estimateGas', 'to', to);
            // verify required parameter 'value' is not null or undefined
            (0, common_1.assertParamExists)('estimateGas', 'value', value);
            const localVarPath = `/api/v1/gas/estimate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (data !== undefined) {
                localVarQueryParameter['data'] = data;
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }
            if (value !== undefined) {
                localVarQueryParameter['value'] = value;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get account details by address
         * @param {string} pubkey account address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccount: async (pubkey, options = {}) => {
            // verify required parameter 'pubkey' is not null or undefined
            (0, common_1.assertParamExists)('getAccount', 'pubkey', pubkey);
            const localVarPath = `/api/v1/account/{pubkey}`
                .replace(`{${"pubkey"}}`, encodeURIComponent(String(pubkey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the current recommended gas fees to use in a transaction  * For EIP-1559 transactions, use `maxFeePerGas` and `maxPriorityFeePerGas` * For Legacy transactions, use `gasPrice`
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGasFees: async (options = {}) => {
            const localVarPath = `/api/v1/gas/fees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get information about the running coinstack
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInfo: async (options = {}) => {
            const localVarPath = `/api/v1/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get transaction history by address
         * @param {string} pubkey account address
         * @param {string} [cursor] the cursor returned in previous query (base64 encoded json object with a \&#39;page\&#39; property)
         * @param {number} [pageSize] page size (10 by default)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxHistory: async (pubkey, cursor, pageSize, options = {}) => {
            // verify required parameter 'pubkey' is not null or undefined
            (0, common_1.assertParamExists)('getTxHistory', 'pubkey', pubkey);
            const localVarPath = `/api/v1/account/{pubkey}/txs`
                .replace(`{${"pubkey"}}`, encodeURIComponent(String(pubkey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sends raw transaction to be broadcast to the node.
         * @param {SendTxBody} sendTxBody serialized raw transaction hex
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTx: async (sendTxBody, options = {}) => {
            // verify required parameter 'sendTxBody' is not null or undefined
            (0, common_1.assertParamExists)('sendTx', 'sendTxBody', sendTxBody);
            const localVarPath = `/api/v1/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(sendTxBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.V1ApiAxiosParamCreator = V1ApiAxiosParamCreator;
/**
 * V1Api - functional programming interface
 * @export
 */
const V1ApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.V1ApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get the estimated gas cost of a transaction
         * @param {string} data input data
         * @param {string} from from address
         * @param {string} to to address
         * @param {string} value transaction value in wei
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async estimateGas(data, from, to, value, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.estimateGas(data, from, to, value, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Get account details by address
         * @param {string} pubkey account address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccount(pubkey, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccount(pubkey, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Get the current recommended gas fees to use in a transaction  * For EIP-1559 transactions, use `maxFeePerGas` and `maxPriorityFeePerGas` * For Legacy transactions, use `gasPrice`
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGasFees(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGasFees(options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Get information about the running coinstack
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInfo(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInfo(options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Get transaction history by address
         * @param {string} pubkey account address
         * @param {string} [cursor] the cursor returned in previous query (base64 encoded json object with a \&#39;page\&#39; property)
         * @param {number} [pageSize] page size (10 by default)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTxHistory(pubkey, cursor, pageSize, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTxHistory(pubkey, cursor, pageSize, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Sends raw transaction to be broadcast to the node.
         * @param {SendTxBody} sendTxBody serialized raw transaction hex
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendTx(sendTxBody, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendTx(sendTxBody, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.V1ApiFp = V1ApiFp;
/**
 * V1Api - factory interface
 * @export
 */
const V1ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.V1ApiFp)(configuration);
    return {
        /**
         * Get the estimated gas cost of a transaction
         * @param {string} data input data
         * @param {string} from from address
         * @param {string} to to address
         * @param {string} value transaction value in wei
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        estimateGas(data, from, to, value, options) {
            return localVarFp.estimateGas(data, from, to, value, options).then((request) => request(axios, basePath));
        },
        /**
         * Get account details by address
         * @param {string} pubkey account address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccount(pubkey, options) {
            return localVarFp.getAccount(pubkey, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the current recommended gas fees to use in a transaction  * For EIP-1559 transactions, use `maxFeePerGas` and `maxPriorityFeePerGas` * For Legacy transactions, use `gasPrice`
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGasFees(options) {
            return localVarFp.getGasFees(options).then((request) => request(axios, basePath));
        },
        /**
         * Get information about the running coinstack
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInfo(options) {
            return localVarFp.getInfo(options).then((request) => request(axios, basePath));
        },
        /**
         * Get transaction history by address
         * @param {string} pubkey account address
         * @param {string} [cursor] the cursor returned in previous query (base64 encoded json object with a \&#39;page\&#39; property)
         * @param {number} [pageSize] page size (10 by default)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTxHistory(pubkey, cursor, pageSize, options) {
            return localVarFp.getTxHistory(pubkey, cursor, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Sends raw transaction to be broadcast to the node.
         * @param {SendTxBody} sendTxBody serialized raw transaction hex
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTx(sendTxBody, options) {
            return localVarFp.sendTx(sendTxBody, options).then((request) => request(axios, basePath));
        },
    };
};
exports.V1ApiFactory = V1ApiFactory;
/**
 * V1Api - object-oriented interface
 * @export
 * @class V1Api
 * @extends {BaseAPI}
 */
class V1Api extends base_1.BaseAPI {
    /**
     * Get the estimated gas cost of a transaction
     * @param {V1ApiEstimateGasRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    estimateGas(requestParameters, options) {
        return (0, exports.V1ApiFp)(this.configuration).estimateGas(requestParameters.data, requestParameters.from, requestParameters.to, requestParameters.value, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get account details by address
     * @param {V1ApiGetAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    getAccount(requestParameters, options) {
        return (0, exports.V1ApiFp)(this.configuration).getAccount(requestParameters.pubkey, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the current recommended gas fees to use in a transaction  * For EIP-1559 transactions, use `maxFeePerGas` and `maxPriorityFeePerGas` * For Legacy transactions, use `gasPrice`
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    getGasFees(options) {
        return (0, exports.V1ApiFp)(this.configuration).getGasFees(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get information about the running coinstack
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    getInfo(options) {
        return (0, exports.V1ApiFp)(this.configuration).getInfo(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get transaction history by address
     * @param {V1ApiGetTxHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    getTxHistory(requestParameters, options) {
        return (0, exports.V1ApiFp)(this.configuration).getTxHistory(requestParameters.pubkey, requestParameters.cursor, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Sends raw transaction to be broadcast to the node.
     * @param {V1ApiSendTxRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    sendTx(requestParameters, options) {
        return (0, exports.V1ApiFp)(this.configuration).sendTx(requestParameters.sendTxBody, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.V1Api = V1Api;
